(function () {
  if (window.CravotHeroGrid) return;

  function setVideoState(button, shouldPause) {
    var container = button.closest('[data-cravot-hero-grid]');
    var video = container && container.querySelector('video');
    if (!video) return;

    if (shouldPause) {
      video.pause();
    } else {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    button.setAttribute('aria-pressed', shouldPause ? 'true' : 'false');
    button.setAttribute('aria-label', shouldPause ? 'Play background video' : 'Pause background video');
  }

  function initialize(scope) {
    var root = scope || document;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-cravot-video-toggle]').forEach(function (button) {
      if (button.dataset.cravotVideoReady === 'true') return;
      button.dataset.cravotVideoReady = 'true';
      if (reduceMotion) setVideoState(button, true);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cravot-video-toggle]');
    if (!button) return;
    setVideoState(button, button.getAttribute('aria-pressed') !== 'true');
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  window.CravotHeroGrid = { initialize: initialize };
})();
